import React, { useEffect, useRef, useState } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import useAxiosProtect from '../../../../../../hooks/useAxiosProtect';
import useAuth from '../../../../../../hooks/useAuth';
import jwtDecode from 'jwt-decode';
import { Form } from 'react-bootstrap';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { CancelRounded, Check } from '@mui/icons-material';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';

const PHRegistry = props => {
    const axiosProtect = useAxiosProtect();
    const [tempSensors, setTempSensors] = useState([]);

    var init = useRef(true);

    useEffect(() => {
        if(!init.current) return;
        init.current = false;

        axiosProtect.get(`/mls/milesight?site_id=${window.location.href.split('/').slice(-1)[0]}&sensor_type=ph`).then(response => {
            setTempSensors(response.data.sensors);

        }).catch(error => {});
    }, []);

    return (
        <div>
            <Button onClick={() => {
                // setModalType('create');
                // setShowGasModal(true);
            }} variant='outline-dark' style={{marginBottom:'1.5%'}}>
                <strong>Add temperature sensor</strong>
            </Button>

            <Table>
                <thead>
                    <th>Name</th>
                    <th>Active</th>
                    <th>Type</th>
                    <th>DevEUI</th>
                    <th>Actions</th>
                </thead>

                <tbody>
                    {tempSensors.map((unit, i) => (
                        <tr key={`temperature${i}`}>
                            <td>{unit.name}</td>
                            <td>
                                <Form.Check
                                    type="switch"
                                    id={`centrica-ct-active-switch-${i}`}
                                    className='centrica-table-switch'
                                    onClick={() => {
                                        if(unit.active){
                                            // setCTModalData(ct);
                                            // setCTModalState('toggle');
                                        }else{
                                            // toggleCTStatus(ct.id);
                                        }
                                    }}
                                    label={unit.active ? 'active' : 'disabled'}
                                    checked={unit.active}
                                />
                            </td>
                            <td>{unit.deveui !== undefined ? 'Milesight' : 'Other'}</td>
                            <td>{unit.deveui}</td>
                            <td>
                                <IconButton style={{height:'fit-parent', width:'auto'}} onClick={() => {
                                    // setCTModalData(ct);
                                    // setCTModalState('delete');
                                }}>
                                    <DeleteTwoToneIcon style={{fill: "red"}}/>
                                </IconButton>

                                <IconButton style={{height:'fit-parent', width:'auto'}} onClick={() => {
                                    // setCTModalData(ct);
                                    // setCTModalState('edit');
                                }}>
                                    <EditTwoToneIcon />
                                </IconButton>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}

export default PHRegistry;